//COMMON
export enum ELng { 
  //#region COMMON------------------------------------------------------------------------------------
  //#region unassigned
  _null = "_null",
  //#endregion

  
  //#region buttonLabelsCommon
  button_cancel = "button_cancel",
  button_confirm = "button_confirm",
  button_save = "button_save",
  button_assign = "button_assign",
  button_submit = "button_submit",
  //#endregion


  //#region inputValidation
  iv_at_least_one_special_character_is_required= "iv_at_least_one_special_character_is_required",
  iv_at_least_8_characters_are_required = "iv_at_least_8_characters_are_required",
  iv_at_least_one_lowercase_letter_is_required = "iv_at_least_one_lowercase_letter_is_required",
  iv_at_least_one_uppercase_letter_is_required = "iv_at_least_one_uppercase_letter_is_required",
  iv_invalid_common_isrequired_1 = "iv_invalid_common_isrequired_1",
  iv_invalid_common_isrequired_2 = "iv_invalid_common_isrequired_2",
  iv_invalid_common_isrequired_3 = "iv_invalid_common_isrequired_3",
  iv_invalid_common_isrequired_4 = "iv_invalid_common_isrequired_4",
  iv_invalid_common_isrequired_8 = "iv_invalid_common_isrequired_8",
  iv_invalid_document_external_desc = "iv_invalid_document_external_desc",
  iv_invalid_date = "iv_invalid_date",
  iv_invalid_email= "iv_invalid_email",
  iv_invalid_inc_apq_is_empty_or_nan = "iv_invalid_inc_apq_is_empty_or_nan",
  iv_invalid_inc_apq_zero = "iv_invalid_inc_apq_zero",
  iv_invalid_inc_apq_is_wrong_number = "iv_invalid_inc_apq_is_wrong_number",
  iv_invalid_phone= "iv_invalid_phone",
  iv_invalid_postalcode = "iv_invalid_postalcode",
  iv_invalid_rfa_pa_consequences = "iv_invalid_rfa_pa_consequences",
  iv_invalid_status = "iv_invalid_status",
  iv_invalid_type = "iv_invalid_type",
  iv_invalid_role = "iv_invalid_role",
  iv_invalid_user_deputy = "iv_invalid_user_deputy",
  iv_invalid_user_responsible = "iv_invalid_user_responsible",
  iv_invalid_web = "iv_invalid_web",
  iv_invalid_written_by = "iv_invalid_written_by",
  iv_warning_status_deleted = "iv_warning_status_deleted",
  iv_no_whitespaces_allowed = "iv_no_whitespaces_allowed",
  iv_number_characters_are_required= "iv_number_characters_are_required",
  iv_old_password_required = "iv_old_password_required",
  iv_passwords_do_not_match = "iv_passwords_do_not_match",
  iv_password_new_equals_current = "iv_password_new_equals_current",
  //#endregion

  
  //#region languages
  lng_en = "lng_en",
  lng_dn = "lng_de",
  //#endregion


  //#region messages
  msg_access_forbidden = "msg_access_forbidden",
  msg_error_common = "msg_error_common",
  msg_error_unknown = "msg_error_unknown",
  msg_error_contact_service = "msg_error_contact_service!",
  msg_error_document_is_null_or_undefined = "msg_error_document_is_null_or_undefined",
  msg_error_file_is_undefined = "msg_error_file_is_undefined",
  msg_error_item_is_null = "msg_error_item_is_null",
  msg_error_jsons_are_null = "msg_error_jsons_are_null",
  msg_error_jsons_are_null_user = "msg_error_jsons_are_null_user",
  msg_error_mapping = "msg_error_mapping",
  msg_error_on_logout = "msg_error_on_logout",
  msg_error_on_login = "msg_error_on_login",
  msg_error_on_insert = "msg_error_on_insert",
  msg_error_on_update = "msg_error_on_update",
  msg_error_on_upload = "msg_error_on_upload",
  msg_error_on_upload_picture = "msg_error_on_upload_picture",
  msg_error_on_download = "msg_error_on_download",

  msg_error_sectionParent_is_null = "msg_error_sectionParent_is_null",
  msg_error_section_uuid_equals_sectionParent_uuid = "msg_error_section_uuid_equals_sectionParent_uuid",
  msg_error_uuid_is_null = "msg_error_uuid_is_null",

  msg_info_common = "msg_info_common",
  msg_is_registration_auth_timeout = "msg_is_registration_auth_timeout",

  msg_missing_prop_password = "msg_missing_prop_password",
  msg_missing_prop_name = "msg_missing_prop_name",
  msg_missing_prop_firstname = "msg_missing_prop_firstname",
  msg_missing_prop_surname = "msg_missing_prop_surname",
  msg_missing_prop_email = "msg_missing_prop_email",
  msg_missing_prop_phone = "msg_missing_prop_phone",
  msg_missing_prop_terms_accepted = "msg_missing_prop_terms_accepted",

  msg_no_data_to_submit = "msg_no_data_to_submit",

  msg_success_on_email_send = "msg_success_on_email_send",

  msg_success_common = "msg_success_common",
  msg_success_on_delete = "msg_success_on_delete",
  msg_success_on_insert = "msg_success_on_insert",
  msg_success_on_update = "msg_success_on_update",
  msg_success_on_register_request = "msg_success_on_register_request",
  msg_success_on_register_reset = "msg_success_on_register_reset",
  msg_success_on_password_reset_request = "msg_success_on_password_reset_request",
  msg_success_on_password_reset_reset = "msg_success_on_password_reset_reset",
  msg_success_on_password_update = "msg_success_on_password_update",

  msg_warning_common = "msg_warning_common",
  //#endregion
  
  //#region placeholer
  placeholder_common_description = "placeholder_common_description",
  placeholder_common_email = "placeholder_common_email",
  placeholder_common_message = "placeholder_common_message",
  placeholder_common_name = "placeholder_common_name",
  placeholder_common_subject = "placeholder_common_subject",
  placeholder_common_title = "placeholder_common_title",
  placeholder_common_type = "placeholder_common_type",

  placeholder_common_search ="placeholder_common_search",
  placeholder_document_search = "placeholder_document_search",
  placeholder_documenttosections_search = "placeholder_documenttosections_search",
  placeholder_documenttoitems_search = "placeholder_documenttoitems_search",
  placeholder_document_author = "placeholder_document_author",
  placeholder_document_title = "placeholder_document_title",
  placeholder_toms_search = "placeholder_toms_search",
  placeholder_user_search ="placeholder_user_search",
  placeholder_usertosection_search = "placeholder_usertosection_search",
  //#endregion

 //#region propNamesCommon
  prop_name = "prop_name",
  prop_email = "prop_email",
  prop_email_subject = "prop_email_subject",
  prop_email_message = "prop_email_message",
  //#endregion


  //#region sign_in_up_out
  sign_in_header = "sign_in_header",
  sign_in_sentence = "sign_in_sentence",
  sign_up_long = "sign_up_long",
  sign_out = "sign_out",
  //#endregion

  
  //#region titlesCommon
  title_document_files = "title_document_files",
  title_error_common = "title_error_common",
  title_error_on_email_send = "title_error_on_email_send",
  title_error_on_insert = "title_error_on_insert",
  title_error_on_update = "modal_title_error_on_update",

  title_warn_common = "title_warn_common",

  title_info_common = "title_info_common",

  title_profile_picture_user = "title_profile_picture_user",
  title_profile_picture_section = "title_profile_picture_section",

  title_success_common = "title_success_common",
  title_success_on_email_send = "title_success_on_email_send",
  title_success_on_insert = "title_success_on_insert",
  title_success_on_update = "title_success_on_update",
  title_section_to_parentsection = "title_section_to_parentsection",
  title_section_to_parentsection_1 = "title_section_to_parentsection_1",

  title_user_contact_persons = "title_user_contact_persons",
  //#endregion
}

//APP---------------------------------------------------------------
export enum ELng {
  //#region APP------------------------------------------------------------------------------------------
  android_app_desc0 = "android_app_desc0",
  android_app_desc1 = "android_app_desc1",
  android_app_desc2 = "android_app_desc2",
  android_app_desc3 = "android_app_desc3",
  android_app_freeversion_desc0 = "android_app_freeversion_desc0",
  android_app_freeversion_desc1 = "android_app_freeversion_desc1",
  android_app_googleplay_header = "android_app_googleplay_header",
  android_app_googleplay_desc = "android_app_googleplay_desc",
  android_app_woh_header = "android_app_woh_header",
  android_app_woh_desc = "android_app_woh_desc",
  android_app_error = "android_app_error",
  //#endregion

  //#region aboutUs
  _ABOUT_US = "_ABOUT_US",
  about_us_0 = "about_us_0",
  about_us_jens = "about_us_jens",
  about_us_jan = "about_us_jan",
  //#endregion

  //#region navigation
  nav_about_us = "nav_about_us",
  nav_privacy_policy = "nav_privacy_policy",
  nav_service = "nav_service",
  nav_woh_site = "nav_woh_site",
  nav_woh_app = "nav_woh_app",
  nav_home = "nav_home",
  //#endregion

  //#region service
  service_header = "service_header",
  service_error_header = "service_error_header",
  service_email_header = "service_email_header",
  service_email_header_sub = "service_email_header_sub",
  service_email_subject = "service_email_subject",
  service_email_address = "service_email_address",
  service_email_message = "service_email_message",
  service_email_hint_required = "service_email_hint_required",
  service_email_send = "service_email_send",
  service_contact_header_main = "service_contact_header_main",
  service_contact_header = "service_contact_header",
  service_contact_email = "service_contact_email",
  service_contact_phone = "service_contact_phone",
  //#endregion

  //#region privacyPolicy
  pp_p0_header0 = "pp_p0_header0",
  pp_p0_header1 = "pp_p0_header1",
  pp_p0_header2 = "pp_p0_header2",
  pp_p1_header0 = "pp_p1_header0",
  pp_p1_header1 = "pp_p1_header1",
  pp_p1_text1 = "pp_p1_text1",
  pp_p1_header2 = "pp_p1_header2",
  pp_p1_text2 = "pp_p1_text2",
  pp_p1_header3 = "pp_p1_header3",
  pp_p1_text3 = "pp_p1_text3",
  //#endregion

  //#region videos
  video_app_blues = "video_app_blues",
  video_app_harmonical_systems = "video_app_harmonical_systems",
  video_app_jazz_iivi = "video_app_jazz_iivi",
  video_app_mixer_user = "video_app_mixer_user",
  video_app_mixer_progression = "video_app_mixer_progression",
  video_app_progressions = "video_app_progressions",
  video_app_promo = "video_app_promo",

  video_web_blues = "video_web_blues",
  video_web_harmonical_systems = "video_web_harmonical_systems",
  video_web_jazz_iivi = "video_web_jazz_iivi",
  video_web_mixer_user = "video_web_mixer_user",
  video_web_mixer_progression = "video_web_mixer_progression",
  video_web_progressions = "video_web_progressions",
  video_web_promo = "video_web_promo",
  //#endregion


  //#region website
  website_header = "website_header",
  website_link_header = "website_link_header",
  website_link_desc = "website_link_desc",

  website_promo_intro_header = "website_promo_intro_header",
  website_promo_intro_desc = "website_promo_intro_desc",
  website_promo_mobiles_tooltip_header = "website_promo_mobiles_tooltip_header",
  website_promo_mobiles_desc = "website_promo_mobiles_desc",
  website_promo_mobiles_header = "website_promo_mobiles_header",

  website_use_supported_browsers = "website_use_supported_browsers",
  website_videogallery_header = "website_videogallery_header"
  //#endregion
}